import createIcon from '../../createIcon';

/**
 * @component @name ShowChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy41IDE4LjQ4OThMOS41IDEyLjQ3OThMMTMuNSAxNi40Nzk4TDIyIDYuOTE5NzdMMjAuNTkgNS41MDk3N0wxMy41IDEzLjQ3OThMOS41IDkuNDc5NzZMMiAxNi45ODk4TDMuNSAxOC40ODk4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShowChart = createIcon('ShowChart', [
  [
    'path',
    {
      d: 'M3.5 18.4898L9.5 12.4798L13.5 16.4798L22 6.91977L20.59 5.50977L13.5 13.4798L9.5 9.47976L2 16.9898L3.5 18.4898Z',
      key: '13pqio',
    },
  ],
]);

export default ShowChart;
